import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import {update} from "../../../app/setters/update.js";

export const useModyfikujPozycjeSlownika = () => {

    const [slownikData, setSlownikData] = useState({})
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data) => update(`/slowniki/${data.slownik}`, {...data?.data}),
        onError: () => {
            toast.error('Błąd podczas operacji')
        },
        onMutate: (data) => {
            setSlownikData(data?.slownik)
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({
                queryKey: [`pozycje_slownika__${slownikData}`]
            })
        },

        onSuccess: ({message}) => {
            toast.success(message)
            navigate(`/oper/slownik/${slownikData}/lista`)
        }
    })
}